<template>
  <!-- 日期选择框 -->
  <!-- 分开选择开始和结束，配合type有分开选择日期、日期时间、日期时间区间范围 -->
  <!-- 3个参数  1 dateAndTime 赋值为true dateAndTime不赋值或者赋值为false只有一个date组件  
               2 dateType 赋值有 date datetime daterange datetimerange
               3 valueFormat 返回数据格式-->
  <div>
    <el-popover
      placement="bottom-start"
      :width="headerItem.dateAndTime?500:220"
      trigger="click"
      :ref="'popover' + headerIndex"
    >
      <template #reference>
        <div class="search-header hand" v-if="headerItem.type == 'InputSearch'">
          <span class="search-title">{{ headerItem.label }}</span>
          &nbsp;<el-icon style="vertical-align: middle">
            <Search />
          </el-icon>
        </div>
        <div class="search-header hand" v-else>
          <span class="search-title">{{ headerItem.label }}</span>
          &nbsp;<el-icon style="vertical-align: middle">
            <ArrowDown />
          </el-icon>
        </div>
      </template>
      <template v-if="headerItem.dateAndTime">
        <el-date-picker
          :key="key"
          :type="headerItem.dateType"
          class="allocation-right left"
          placeholder="选择开始日期时间"
          v-model="headerItem[headerItem.prop + 'Start']"
          :format="
            headerItem.valueFormat != undefined ? headerItem.valueFormat : 'YYYY-MM-DD'
          "
          :value-format="
            headerItem.valueFormat != undefined ? headerItem.valueFormat : 'YYYY-MM-DD'
          "
          :teleported="false"
          @change="
            datePickerChange(headerIndex, {
              name: 'dateAndTime',
              prop: headerItem.prop,
              value: {
                start: headerItem[headerItem.prop + 'Start'],
                end: headerItem[headerItem.prop + 'End'],
              },
              row: scope,
              type: headerItem.dateType,
              formatSearch: headerItem.valueFormat ? headerItem.valueFormat : '',
            })
          "
          clearable
        />
        <span class="mar-10">至</span>
        <el-date-picker
          :key="key"
          :teleported="false"
          :type="headerItem.dateType"
          class="allocation-right left"
          placeholder="选择结束日期时间"
          v-model="headerItem[headerItem.prop + 'End']"
          :format="
            headerItem.valueFormat != undefined ? headerItem.valueFormat : 'YYYY-MM-DD'
          "
          :value-format="
            headerItem.valueFormat != undefined ? headerItem.valueFormat : 'YYYY-MM-DD'
          "
          @change="
            datePickerChange(headerIndex, {
              name: 'dateAndTime',
              prop: headerItem.prop,
              value: {
                start: headerItem[headerItem.prop + 'Start'],
                end: headerItem[headerItem.prop + 'End'],
              },
              row: scope,
              type: 'dateAndTime',
              formatSearch: headerItem.valueFormat ? headerItem.valueFormat : '',
            })
          "
          clearable
        >
        </el-date-picker>
      </template>
      <el-date-picker
        :key="key"
        v-else-if="isInclude(headerItem.dateType, 'time')"
        :type="headerItem.dateType"
        placeholder="选择日期时间"
        v-model="headerItem[headerItem.prop]"
        :format="headerItem.format || 'YYYY-MM-DD'"
        :value-format="
          headerItem.valueFormat != undefined ? headerItem.valueFormat : 'YYYY-MM-DD'
        "
        range-separator="至"
        :teleported="false"
        @change="
          datePickerChange(headerIndex, {
            name: 'date',
            prop: headerItem.prop,
            value: headerItem[headerItem.prop],
            type: headerItem.dateType,
            row: scope,
            formatSearch: headerItem.valueFormat ? headerItem.valueFormat : '',
          })
        "
      />
      <el-date-picker
        v-else
        v-show="condition"
        v-model="headerItem[headerItem.prop]"
        :type="headerItem.dateType"
        range-separator="至"
        start-placeholder="请选择开始时间"
        end-placeholder="请选择结束时间"
        :teleported="false"
        :format="
          headerItem.valueFormat != undefined
            ? headerItem.valueFormat
            : 'YYYY-MM-DD HH:mm:ss'
        "
        :value-format="
          headerItem.valueFormat != undefined
            ? headerItem.valueFormat
            : 'YYYY-MM-DD HH:mm:ss'
        "
        @focus=""
        @change="
          datePickerChange(headerIndex, {
            name: 'date',
            prop: headerItem.prop,
            value: headerItem[headerItem.prop],
            type: headerItem.dateType,
            row: scope,
            formatSearch: headerItem.valueFormat ? headerItem.valueFormat : '',
          })
        "
      />
    </el-popover>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive, toRefs } from "vue";
import { useStore } from "vuex";
export default {
  name: "DateSelect",
  components: {},
  props: {
    headerItem: Object,
    headerIndex: Number,
    key: Number,
    height: Number,
    scope: Object,
  },
  // 定义属性
  setup(props, { emit }) {
    const data = reactive({
      condition: true,
    });
    const store = useStore();
    const refData = toRefs(data);
    const datePickerChange = (index, option) => {
      console.log("选中时间参数", option);
      emit("searchFnc", option);
    };
    const isInclude = (val, data) => {
      return val.indexOf(data) == -1;
    };
    return {
      ...refData,
      datePickerChange,
      isInclude,
    };
  },
};
</script>

<style scoped>
.StudentClassAllocation_posi {
  line-height: 32px;
  margin-right: 20px
}

*/deep/.left.el-date-editor.el-input {
  float: left;
  width: 200px !important;
  box-sizing: border-box;
}

/deep/.el-input__icon {
  margin-top: 1px !important;
}

/* /deep/.clear-icon {
  margin-top: 12px !important;
} */

.left {
  /* float: left; */
  /* margin: 0 5px; */
}

.el-select >>> .el-input__suffix {
  display: inline-flex;
}
.mar-10{
  margin: 0 10px;
}
</style>
